import React from 'react';
import I18n from '@/modules/i18n';
import SessionPopup from '@/components/common/SessionPopup';
import Icon from '@/components/ui/Icon';
import useSlideShowContext from '@/components/admin/SlideShow/stores/useSlideShowContext';

interface SessionConflictModalProps {
  modalManager: ModalManager;
}

// AIDEV-NOTE: PLAT-17309 — Two flavors of conflict. `ownActiveSessionElsewhere` is the same
// teacher with a session on a different slideshow (shorter "only one session" copy).
// Default copy explains another teacher in the classroom holds the session.
const SessionConflictModal = ({ modalManager }: SessionConflictModalProps) => {
  const ownActiveSessionElsewhere = useSlideShowContext(state => state.ownActiveSessionElsewhere);
  const bodyKey = ownActiveSessionElsewhere ? 'tpm_self_conflict_body' : 'tpm_conflict_body';

  return (
    <SessionPopup
      body={I18n.t(bodyKey)}
      headline={{
        id: 'session-conflict-headline',
        text: I18n.t('tpm_conflict_headline'),
      }}
      icon={<Icon color="white" icon="InfoAlternate" size={30} />}
      isOpen={modalManager.isOpen}
      primaryButton={{
        onClick: modalManager.close,
        text: I18n.t('close'),
        variant: 'purple',
      }}
      onClose={modalManager.close}
    />
  );
};

export default SessionConflictModal;
